// The transaction-type categories, shared by the Transactions page's filter
// and the Strategy Report's Bucket 3 income setting (task 6137), which offer
// the same seven.

export interface TransactionTypeCategory {
  value: string;
  label: string;
}

// Categories rather than Orion's raw type names: Orion sends ~40 of those and
// a user asks for "Deposits", which is nine of them. The values are the API's
// own -- their single home is TRANSACTION_TYPE_CATEGORY_IDS in the backend's
// services/transaction_utils.py, which derives each set from the same enums the
// report calculations use.
//
// All seven are always offered, including any with no rows: the six are a fixed
// product concept, so the page can list them itself and costs no extra request
// to build the dropdown. A category matching nothing renders as the grid's own
// "No rows" rather than as a missing option.
//
// This list is a hand-kept copy across the language boundary, which is how this
// app carries such a list (see PDF_REPORT_PLACEHOLDER_VALUES). Two tests keep
// the halves in step, one per direction, because the API refuses a value it
// does not recognise -- a typo here is not a wide result set but a checkbox
// that answers 400 and empties the grid. The backend names these seven values
// as literals, and TransactionsList.test sends each label and asserts the value
// it emits.
export const TRANSACTION_TYPE_CATEGORIES: TransactionTypeCategory[] = [
  { value: "buys", label: "Buys" },
  { value: "sells", label: "Sells" },
  { value: "deposits", label: "Deposits" },
  { value: "withdrawals", label: "Withdrawals" },
  { value: "dividends", label: "Dividends" },
  { value: "margin_interest", label: "Margin Interest" },
  // Every type id in none of the six -- internal journals and the rest. Without
  // it those rows would be visible only with the filter cleared.
  { value: "other", label: "Other" },
];
